import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';
import { PricingTierItemDto } from '../../../shared/modules/pricing-tier-items/dtos/pricing-tier-item.dto';

/**
 * Quotation response DTO
 */
export class QuotationResponseDto {
  /**
   * Vehicle id
   */
  vehicleId?: number;

  /**
   * Vehicle category id
   */
  vehicleCategoryId?: number;

  /**
   * Duration unit
   */
  durationUnit!: DurationUnitEnum;

  /**
   * Duration
   */
  duration!: number;

  /**
   * Date from
   */
  dateFrom!: Date;

  /**
   * Date to
   */
  dateTo!: Date;

  /**
   * Computed total net amount
   */
  computedTotalNet?: number;

  /**
   * Computed total tax amount
   */
  computedTotalTax?: number;

  /**
   * Computed total gross amount
   */
  computedTotalGross?: number;

  /**
   * Computed standard subtotal (base rental only, excludes extras)
   */
  computedStandardNet?: number;
  computedStandardTax?: number;
  computedStandardGross?: number;

  /**
   * Computed discount net amount (positive magnitude; vehicle-category / discountable net only)
   */
  computedDiscountNet?: number;
  computedDiscountTax?: number;
  computedDiscountGross?: number;

  /**
   * Computed extras subtotal (sum of extra pricing items)
   */
  computedExtrasNet?: number;
  computedExtrasTax?: number;
  computedExtrasGross?: number;

  /**
   * Vehicle category discount percentage (0-100)
   */
  standardDiscountPercentage?: number;

  /**
   * Vehicle-category deposit amount for the quoted duration
   */
  computedDepositAmount?: number;

  /**
   * Computed savings amount
   */
  computedSavingsAmount?: number;

  /**
   * Computed savings as a percentage of that tiered reference total
   */
  computedSavingsPercentage?: number;

  /**
   * Original standard amount (standard gross + savings)
   */
  computedOriginalStandardAmount?: number;

  /**
   * Per-unit commission rate resolved for the agent / vehicle-category pair
   */
  unitCommissionRate?: number;

  /**
   * Whether commission applies for the agent / vehicle-category pair
   */
  isCommissionEligible?: boolean;

  /**
   * Pricing items
   */
  pricingItems?: PricingTierItemDto[];
}
